const homepageAltTextI18nEn = {
  // Banner Slider Images - Desktop
  'altTextBanner1': 'Online fashion repair service Repair Rebels Düsseldorf',
  'altTextBanner3': 'Professional clothing repair and alteration services',
  'altTextBanner4': 'Digital fashion repair platform Repair Rebels',
  'altTextBanner7': 'Eco-friendly clothing repair and maintenance',
  'altTextBanner8': 'Online clothing repair and alteration service',
  
  // Banner Slider Images - Mobile
  'altTextMobileBanner1': 'Sustainable fashion repair service',
  'altTextMobileBanner2': 'Clothing repair and alteration service',
  'altTextMobileBanner3': 'Professional fashion repair platform',
  'altTextMobileBanner5': 'Online textile and shoe repair service',
  
  // Video Section
  'videoTitleRecommended': 'Sustainable Fashion Repair Service - How it works?',
  
  // Club Section
  'altTextWomanImage': 'Repair Rebels Club – exclusive membership benefits',
  
  // Partnerships Section
  'altTextPartnershipsBgNew': 'After-sales repair services for fashion brands - corporate partnerships',
  'altTextPartnershipsBgSm': 'White-label repair solution for fashion brands',
  'altTextLogo': 'Repair Rebels B2B partnerships - repair software',
};

export default homepageAltTextI18nEn;
